//Wishlist Area
  function wishlist_init(){    
    if(localStorage.getItem('wishlist-id') == '[]' || localStorage.getItem('wishlist-id') == null ){
      $('.wlnumber').html('0');
    }
    else{
      var activeID = [];
      activeID = JSON.parse(localStorage.getItem('wishlist-id'));
      $('.wlnumber').html(activeID.length);     
      for(i=0; i<activeID.length; i++ ){
        var classadded = '.wl-'+activeID[i];        
        $(classadded).addClass("wlc-added").removeClass("wlc").attr("title","Wishlist Added");
      }
    }
  }

  function wishlist_add(){
    $( "a.wlc" ).on( "click", function(e) {
      if(!$(this).hasClass('wlc-added')){
        e.preventDefault();                  

        //store product ID      
        var storeID = [];
        if(localStorage.getItem('wishlist-id') == null )
          storeID = [];
        else
          storeID = JSON.parse(localStorage.getItem('wishlist-id'));
        storeID.push($(this).data("wishlistid"));
        localStorage.setItem('wishlist-id', JSON.stringify(storeID));  
            
        
        //fly        
        var wlicon = $('#float-wishlist');
        if(!$(this).hasClass('pdp-wlc')){
          var imgtodrag = $(this).closest('.grid-view-item').find("img").eq(0);
        } else {
          var imgtodrag = $(this).closest('.product-leftsidebar').find("#ProductPhoto img").eq(0);
        }
        if (imgtodrag) {
          var imgclone = imgtodrag.clone()
          .offset({
            top: imgtodrag.offset().top,
            left: imgtodrag.offset().left
          })
          .css({
            'opacity': '0.5',
            'position': 'absolute',
            'height': '150px',
            'width': '150px',
            'z-index': '100'
          })
          .appendTo($('body'))
          .animate({
            'top': wlicon.offset().top + 10,
            'left': wlicon.offset().left + 10,
            'width': 75,
            'height': 75
          }, 1000);

          $('#float-wishlist').css("background","red");
          setTimeout(function () {
            $('#float-wishlist').css("background","");
          }, 1500);

          imgclone.animate({
            'width': 0,
            'height': 0
          }, function () {
            $(this).detach()
          });
        }
        
        
        //add class and update count
        setTimeout(function () {$('.wlnumber').html(storeID.length)},1000);
        $(this).addClass("wlc-added").removeClass("wlc").attr("title","Wishlist Added");
      }     
    });
  }  
  
  function wishlist_show(){    
    var cont = '#wishlistcontent ul',
        productjson = '/products.json',
        getID= [];
    if(localStorage.getItem('wishlist-id') != '[]' && localStorage.getItem('wishlist-id') != null ){
      $('.wltable').removeClass('hide');
      getID = JSON.parse(localStorage.getItem('wishlist-id'));
      for(j=0; j<getID.length; j++){
        var url = "/products/"+getID[j]+".js";
        jQuery.getJSON(url, function(product) {
          console.log(234);
          var wcn = ".wishlist-"+product.handle;    
          $(cont).append('<li class="wlr wishlist-'+product.handle+' grid__item one-whole"><div class="wishlist-image grid__item two-tenths"></div><div class="wishlist-name grid__item three-tenths"></div><div class="wishlist-price grid__item two-tenths"></div><div class="wishlist-remove grid__item one-tenth" data-wishlistid="'+product.handle+'"><i class="fa fa-times" aria-hidden="true"></i></div><div class="wishlist-detail grid__item two-tenths"></div></li>');                    
          $(wcn).find('.wishlist-image').append('<img src="'+product.featured_image+'" alt="" />');          
          $(wcn).find('.wishlist-name').append('<a href="'+product.url+'">'+product.title+'</a>'); 
          var price_compare = "";
          if ( product.compare_at_price != null ){
            price_compare='<del class="price_compare"><span class="money">'+ Shopify.formatMoney(product.compare_at_price, moneyFormat) +'</span></del>';
          }
          $(wcn).find('.wishlist-price').append('<span class="price money">'+Shopify.formatMoney(product.price, moneyFormat) + '</span>'+ price_compare);              
          $(wcn).find('.wishlist-remove').on("click", function(){ 
            $(wcn).hide("fade");
            var storeID2= [],
                ri = $(this).data("wishlistid");            
            storeID2 = JSON.parse(localStorage.getItem('wishlist-id'));            
            storeID2 = jQuery.grep(storeID2, function(value) {
              return value != ri;
            });
            localStorage.setItem('wishlist-id', JSON.stringify(storeID2));            
            $('.wlnumber').html(storeID2.length);
            if(storeID2.length == 0) {
              $('.wishlist-heading').hide();
              $('.wlempty').removeClass('hide');
            }
          });
          // $(wcn).find('.wishlist-detail').append('<a href="'+product.url+'" >View More</a>');
          let variantId = product.variants[0].id;
          let isDisabled = product.variants[0].available?"":"disabled";
          let buttonLabel = product.variants[0].available?"ADD TO CART":"SOLD OUT";
          $(wcn).find('.wishlist-detail').append('<form action="/cart/add" method="post" enctype="multipart/form-data" id="AddToCartForm"><input type="hidden" name="id" value="'+ variantId +'"><button type="submit" name="add" id="AddToCart" class="btn" '+ isDisabled +'>'+ buttonLabel +'</button></form>');
        });
      }
    }
    else{      
      $('.wishlist-heading').hide();   
      $('.wlempty').removeClass('hide');
    }
  }
  

//Compare Area
  function compare_init(){    
    if(localStorage.getItem('compare-id') == '[]' || localStorage.getItem('compare-id') == null){
      $('.cpnumber').html('0');
    }
    else{      
      var activeID = [];
      activeID = JSON.parse(localStorage.getItem('compare-id'));
      $('.cpnumber').html(activeID.length);     
      for(i=0; i<activeID.length; i++ ){
        var classadded = '.cm-'+activeID[i];        
        $(classadded).addClass("cmc-added").removeClass("cmc").attr("title","Compare Added");
      }
    }
  }

  function compare_add(){
    $( "a.cmc" ).on( "click", function(e) {
      if(!$(this).hasClass('cmc-added')){
        e.preventDefault();    
        
        //store product ID      
        var storeID = [];
        if(localStorage.getItem('compare-id') == null )
          storeID = [];
        else
          storeID = JSON.parse(localStorage.getItem('compare-id'));
        if(storeID.length < 3){
          storeID.push($(this).data("compareid"));
          localStorage.setItem('compare-id', JSON.stringify(storeID));                   
	
          
          //fly        
          var wlicon = $('#float-compare');
          if(!$(this).hasClass('pdp-cmc')){
            var imgtodrag = $(this).closest('.grid-view-item').find("img").eq(0);
          } else {
            var imgtodrag = $(this).closest('.product-leftsidebar').find("#ProductPhoto img").eq(0);
          }
          if (imgtodrag) {
            var imgclone = imgtodrag.clone()
            .offset({
              top: imgtodrag.offset().top,
              left: imgtodrag.offset().left
            })
            .css({
              'opacity': '0.5',
              'position': 'absolute',
              'height': '150px',
              'width': '150px',
              'z-index': '100'
            })
            .appendTo($('body'))
            .animate({
              'top': wlicon.offset().top + 10,
              'left': wlicon.offset().left + 10,
              'width': 75,
              'height': 75
            }, 1000);

            $('#float-compare').css("background","red");
            setTimeout(function () {
              $('#float-compare').css("background","");
            }, 1500);

            imgclone.animate({
              'width': 0,
              'height': 0
            }, function () {
              $(this).detach()
            });
          }
          

          //add class and update count
          setTimeout(function () {$('.cpnumber').html(storeID.length)},1000);
          $(this).addClass("cmc-added").removeClass("cmc").attr("title","Compare Added");
          
        }
        else{
          //Modal
          alert("Limited 3 products in Compare box!");
        }
      }     
    });
  }    
        
  function compare_check(){
    $( "#float-compare" ).on( "click", function(e) {      
      if(localStorage.getItem('compare-id') == null || localStorage.getItem('compare-id') == '[]' ){         
        $('.compare0-content').show();  
        $('.compare1-content').hide();
        $('.compare-content').hide();
      }
      else{
        var storeID = [];
        storeID = JSON.parse(localStorage.getItem('compare-id'));
        if(storeID.length == 1 ){          
          $('.compare0-content').hide();  
          $('.compare1-content').show();
          $('.compare-content').hide();
        }
        else{                      
          $('.compare0-content').hide();  
          $('.compare1-content').hide();
          $('.compare-content').show();          
          compare_show();
          setTimeout(
            function(){
              $('.compare-box').removeClass('hide');
              $('.compare-loading').hide();
            }, 1000);
        }
      }
    });
  }
        
  function showmfc(){
        
  }
  
  function compare_show(){    
    var cont = '#comparecontent ul',
        productjson = '/products.json',
        getID= [];      
      getID = JSON.parse(localStorage.getItem('compare-id'));   
      if(getID.length == 2) $(".col3").remove();
      for(j=0; j<getID.length; j++){        
        var url = "/products/"+getID[j]+".js";           
        jQuery.getJSON(url, function(product) {          
          var i = 1;
          if($(".compare1-name").html() != "" ) i =2;
          if($(".compare2-name").html() != "" ) i =3;
          var image = ".compare"+i+"-image";
          var name = ".compare"+i+"-name";
          var price = ".compare"+i+"-price";
          var vendor = ".compare"+i+"-vendor";
          var type = ".compare"+i+"-type";
          var variant = ".compare"+i+"-variant";
          var available = ".compare"+i+"-available";
          var remove = ".compare"+i+"-remove";
          var remove1 = ".compare"+i+"-remove .fa-times";
          var detail = ".compare"+i+"-detail";
          
          //image & name
          $(image).html('<a href="'+product.url+'"><img src="'+product.featured_image+'" alt="" /></a>');
          $(name).html('<a href="'+product.url+'">'+product.title+'</a>');
          
          //price
          var price_compare = "";
          if ( product.compare_at_price != null ){
            price_compare='<del class="price_compare"><span class="money">'+ Shopify.formatMoney(product.compare_at_price, moneyFormat) +'</span></del>';
          }          
          $(price).html('<span class="price money">'+Shopify.formatMoney(product.price, moneyFormat) + '</span>'+ price_compare);
          
          //vendor & type
          $(vendor).html(product.vendor);
          $(type).html(product.type);
          
          //variants
          var productVariants = product.variants,
      	      productVariantsCount = productVariants.length,
              VariantOptions='';
          if (productVariantsCount > 1) { 
            for (var i=0; i < productVariantsCount; i++) {
              VariantOptions += '<span>'+ productVariants[i].title +'</span><br/>'
            };
          }
          $(variant).html(VariantOptions);
          
          //stock status
          var stockstatus;
          if(product.available) stockstatus = 'In Stock';
          else stockstatus = 'Out of Stock';
          $(available).html(stockstatus);          
          
          //detail
          $(detail).html('<a href="'+product.url+'">Go Detail</a>');
                
          //remove
          $(remove).html('<i class="fa fa-times" aria-hidden="true"></i>');
          $(remove).attr("data-compareid",product.handle);
          $(remove1).on("click", function(){ 
            var value = "."+$(this).parent().data("remove");
            $(value).hide();
            var storeID2= [],
                ri = $(this).parent().data("compareid"),
                riclass = "."+ri;      
            console.log(riclass);
            storeID2 = JSON.parse(localStorage.getItem('compare-id'));            
            storeID2 = jQuery.grep(storeID2, function(value) {
              return value != ri;
            });
            localStorage.setItem('compare-id', JSON.stringify(storeID2));
            $('.cpnumber').html(storeID2.length);  
            $(riclass).addClass("cmc").removeClass("cmc-added").attr("title","Add to Compare");
            if(storeID2.length == 1){
              $.magnificPopup.close();
            }
          });          
          
        })
      }    
  }

$(document).ready(function($) {
  wishlist_init();
  wishlist_add();
  if(wlpage) wishlist_show();
  
  compare_init();
  compare_add();
  $('#float-compare').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: false,
    tClose: theme.strings.zoomClose,
    alignTop: true,
    removalDelay: 500
  });
  compare_check();    
});